import React, {useState} from 'react';
import styled from 'styled-components';
import {Button, COLORS, SIZES} from '@fupa/fupa-uikit';
import {AutocompleteWrapper} from 'app/components/admin/AutocompleteWrapper';
import {putTopEleven} from 'app/services/api';
import {Snackbar} from '@mui/material';
import {Alert} from '@mui/material';

const Wrapper = styled.div`
  padding: ${SIZES['16']};
  width: 100%;
  margin-top: ${SIZES['16']};
  max-width: 31.25rem;
  background-color: ${COLORS.white};
  @media only screen and (min-width: 62.5rem) {
    max-width: 62.5rem;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  padding-top: ${SIZES['16']};
  width: 100%;
`;

export const SubstitutesForm = ({id}) => {
  const [open, setOpen] = useState(false);
  const [putError, setPutError] = useState(null);
  const [substitutes, setSubstitutes] = useState([]);
  const [error, setError] = useState(false);

  const handleValueChange = (e, values) => setSubstitutes(values);

  const handleValueDelete = (slug) => {
    const newValues = substitutes.filter((value) => value.slug !== slug);
    setSubstitutes(newValues);
  };

  const handleSubmit = () => {
    if (substitutes.length === 5) {
      const substituteObjects = substitutes.map((substitute) => ({player: substitute, position: 'Ersatz'}));
      putTopEleven(id, substituteObjects)
        .then(() => {
          setOpen(true);
        })
        .catch((error) => {
          setOpen(true);
          setPutError(error);
          console.log('Error:', error);
        });
    } else {
      setError(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Wrapper>
      <AutocompleteWrapper
        label='Ersatzspieler'
        error={error}
        values={substitutes}
        helperText='Es müssen genau fünf Ersatzspieler gewählt werden.'
        onValueChange={handleValueChange}
        onValueDelete={handleValueDelete}
      />
      <ButtonContainer>
        <Button label='Speichern' onClick={handleSubmit} />
      </ButtonContainer>
      <Snackbar
        anchorOrigin={{vertical: 'top', horizontal: 'center'}}
        open={open}
        autoHideDuration={3000}
        onClose={handleClose}>
        {putError ? (
          <Alert onClose={handleClose} severity='error'>
            Beim Speichern der Ersatzspieler ist ein Fehler aufgetreten.
          </Alert>
        ) : (
          <Alert onClose={handleClose} severity='success'>
            Ersatzspieler erfolgreich gespeichert.
          </Alert>
        )}
      </Snackbar>
    </Wrapper>
  );
};
